import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Checkbox, Chip, TextField, Typography } from '@mui/material';
import React from 'react'
import WebhookIcon from '@mui/icons-material/Webhook';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DateTimeList from './DateTimeList';

function EnvironmentInherit(props) {
  const { environmentInherit } = props;
  return (
    <div>
      {environmentInherit?.resources.length > 0 &&
        <Typography variant='subtitle2' mt={1}>Resources</Typography>
      }
      {environmentInherit?.resources.map((item, index) => {
        return (
          <Box key={index} className={`flex rounded-sm w-full ${index !== 0 ? 'mt-2' : 'mt-2'}`}>
            <div className='bg-blue-600 p-2 rounded-tl-sm rounded-bl-sm justify-start items-center flex w-[45px]'>
              <WebhookIcon className='text-white' sx={{ fontSize: 28 }} />
            </div>
            <div className={`bg-white px-3 py-1 w-full rounded-tr-sm rounded-br-sm border border-gray-300 flex flex-col overflow-x-auto`}>
              <div>
                <Typography
                  variant='subtitle1'
                  fontSize={{
                    lg: 12,
                    md: 10,
                    sm: 10,
                    xs: 10
                  }}
                  sx={{
                    maxWidth: 190,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item?.name?.client_name || 'Undifined'}
                </Typography>
              </div>
              <div>
                <Typography
                  variant="subtitle2"
                  fontSize={{
                    lg: 10,
                    md: 8,
                    sm: 8,
                    xs: 8
                  }}
                  sx={{
                    color: 'GrayText',
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item?.name?.app_type || 'Undifined'}
                </Typography>
              </div>
            </div>
          </Box>
        )
      })}
      <Box sx={{ marginTop: 2 }}>
        <Accordion
          defaultExpanded
          sx={{
            boxShadow: 'none',
            border: 'none',
            backgroundColor: 'transparent',
            '&::before': { display: 'none' },
            padding: 0,
            margin: 0,
          }}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              padding: 0,
              height: 40,
              minHeight: 40,
              '&.Mui-expanded': {
                height: 40,
                minHeight: 40,
              },
              '& .MuiAccordionSummary-content': {
                margin: 0,
                padding: 0,
              },
              '& .MuiAccordionSummary-expandIconWrapper': {
                margin: 0,
              },
            }}
          >
            <Typography variant='subtitle2'>
              <Checkbox
                sx={{
                  padding: 0,
                  margin: 0,
                  mr: 1,
                }}
                checked={environmentInherit?.ip_address_verification?.ipv4?.active || false}
                disabled
              />
              IP Address Verification
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              marginTop: 2
            }}
          >
            {environmentInherit?.ip_address_verification?.ipv4
              &&
              <div className='flex flex-col gap-4'>
                {(environmentInherit?.ip_address_verification?.ipv4?.wild_card) &&
                  <Autocomplete
                    id="combo-box"
                    size='small'
                    fullWidth
                    multiple
                    freeSolo
                    readOnly
                    // disabled
                    options={[]}
                    value={environmentInherit?.ip_address_verification?.ipv4?.wild_card || null}
                    renderInput={(params) => <TextField
                      {...params}
                      label="IPv4 - Static/Wild Card"
                      // disabled
                    />}
                    renderTags={(value, getTagProps) =>
                      value.map((chip, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                          <Chip
                            key={key}
                            label={chip}
                            {...tagProps}
                          />
                        );
                      })
                    }
                  />
                }
                {(environmentInherit?.ip_address_verification?.ipv4?.subnet_cidr) &&
                  <Autocomplete
                    id="combo-box"
                    size='small'
                    fullWidth
                    multiple
                    freeSolo
                    readOnly
                    // disabled
                    options={[]}
                    value={environmentInherit?.ip_address_verification?.ipv4?.subnet_cidr || null}
                    renderInput={(params) => <TextField
                      {...params}
                      label="IPv4 - CIDR/Subnet"
                      // disabled
                    />}
                    renderTags={(value, getTagProps) =>
                      value.map((chip, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                          <Chip
                            key={key}
                            label={chip}
                            {...tagProps}
                          />
                        );
                      })
                    }
                  />
                }
                {(environmentInherit?.ip_address_verification?.ipv4?.range) &&
                  <Autocomplete
                    id="combo-box"
                    size='small'
                    fullWidth
                    multiple
                    freeSolo
                    readOnly
                    // disabled
                    options={[]}
                    value={environmentInherit?.ip_address_verification?.ipv4?.range || null}
                    renderInput={(params) => <TextField
                      {...params}
                      label="IPv4 - Range"
                      // disabled
                    />}
                    renderTags={(value, getTagProps) =>
                      value.map((chip, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                          <Chip
                            key={key}
                            label={`${chip.start} - ${chip.end}`}
                            {...tagProps}
                          />
                        );
                      })
                    }
                  />
                }
              </div>}
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box sx={{ marginTop: 2 }}>
        <Accordion
          defaultExpanded
          sx={{
            boxShadow: 'none',
            border: 'none',
            backgroundColor: 'transparent',
            '&::before': { display: 'none' },
            padding: 0,
            margin: 0,
          }}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              padding: 0,
              height: 40,
              minHeight: 40,
              '&.Mui-expanded': {
                height: 40,
                minHeight: 40,
              },
              '& .MuiAccordionSummary-content': {
                margin: 0,
                padding: 0,
              },
              '& .MuiAccordionSummary-expandIconWrapper': {
                margin: 0,
              },
            }}
          >
            <Typography variant='subtitle2'>
              <Checkbox sx={{
                padding: 0,
                margin: 0,
                mr: 1,
              }}
                checked={environmentInherit?.date_time_verification?.active || false}
                disabled
              />
              Date time Verification
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
            }}
          >
            <DateTimeList
              // handleOpenDateTimeDialog={handleOpenDateTimeDialog}
              dateTimeConditions={environmentInherit?.date_time_verification?.date_time || []}
              // handleRemoveDateTime={handleRemoveDateTime}
              disabled={true}
              inherit={true}
            />
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  )
}

export default EnvironmentInherit